import ImageArcGISRestClass, * as ImageArcGISRestModule from './../../node_modules/ol/source/ImageArcGISRest.js';

class ImageArcGISRest extends ImageArcGISRestClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageArcGISRestModule) {
    if (key !== "default") {
        ImageArcGISRest[key] = ImageArcGISRestModule[key];
    }
}

export default ImageArcGISRest;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/ImageArcGISRest.js';